import { mfLogoBaseUrl } from '../../../env'
import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'
import ComparisonBarGraphWrapper from '../../../components/graphs/ComparisonBarGraphWrapper'
import { AlertBadge } from './AlertBadge'
import { HeadingWithHighlight } from './HeadingWithHighlight'
import type { SingleFundGraphData } from '../types'

const REGULAR_FUND_COLOR = '#CC5C2D'

interface VariationSingleFundGraphProps {
  data: SingleFundGraphData
}

export function VariationSingleFundGraph({ data }: VariationSingleFundGraphProps) {
  const formattedCommission = roundOffAndFormatNumberWithCurrency(data.commissionAmount)

  return (
    <div className="flex flex-col">
      <AlertBadge label="Regular Fund Detected" />

      <HeadingWithHighlight
        before="High expense ratio in this fund is "
        highlight="impacting your returns"
      />

      <div className="pt-6 overflow-hidden">
        <div className="px-4 pt-[14px] border-[1.5px] border-[#F0F4F7] rounded-[16px] pb-[42px]">
          <FundLogoNameRegular fundName={data.fund.name} logoUrl={data.fund.logoUrl} />
        </div>
        <div className="px-5 pt-5 pb-4 bg-[#FFF2DF] rounded-[16px] -mt-7" >
          <p className="text-[14px] font-[500] pb-6" style={{ color: REGULAR_FUND_COLOR }}>
            {formattedCommission} paid due to high expense ratio
          </p>
          <div className="h-[200px] w-full">
            <ComparisonBarGraphWrapper
              regularValue={data.regularReturns}
              directValue={data.directReturns}
              variant="regularVsDirectReturns"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

interface FundLogoNameRegularProps {
  fundName: string
  logoUrl?: string
}

export function FundLogoNameRegular({ fundName, logoUrl }: FundLogoNameRegularProps) {
  const logoSrc = logoUrl?.startsWith('http') ? logoUrl : `${mfLogoBaseUrl}${logoUrl ?? ''}`

  return (
    <div className="flex items-center gap-4 min-w-0">
      <div className="h-10 w-10 flex-shrink-0">
        <img
          className="h-full w-full object-contain"
          src={logoSrc}
          alt=""
        />
      </div>
      <div className="flex flex-col min-w-0 flex-1">
        <div className="text-[14px] font-[400] text-[#232323] truncate" title={fundName}>
          {fundName}
        </div>
        <div className="text-[13px] font-[500] text-[#CC5C2D] pt-[1px]">
          Regular Fund
        </div>
      </div>
    </div>
  )
}
